import React, { FunctionComponent } from 'react';

/**
 * Info Icon
 */
const InfoIcon: FunctionComponent<React.PropsWithChildren<{ color?: string }>> = ({
  color = 'black'
}) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.00016 0.333344C3.32016 0.333344 0.333496 3.32001 0.333496 7.00001C0.333496 10.68 3.32016 13.6667 7.00016 13.6667C10.6802 13.6667 13.6668 10.68 13.6668 7.00001C13.6668 3.32001 10.6802 0.333344 7.00016 0.333344ZM6.3335 3.66668V5.00001H7.66683V3.66668H6.3335ZM6.3335 6.33334V10.3333H7.66683V6.33334H6.3335ZM1.66683 7.00001C1.66683 9.94001 4.06016 12.3333 7.00016 12.3333C9.94016 12.3333 12.3335 9.94001 12.3335 7.00001C12.3335 4.06001 9.94016 1.66668 7.00016 1.66668C4.06016 1.66668 1.66683 4.06001 1.66683 7.00001Z"
    />
  </svg>
);

export default InfoIcon;
